<template lang="pug">
v-card(
  v-bind="$data.$_attrs"
  v-on="$data.$_listeners"
  :color="color"
  :raised="false"
  :ripple="false"
  :class="classes"
  :style="styles"
).k-card.pa-0
  slot
  a(v-if="closable" @click="$emit('close')").k-card__button--close
    slot(name="close")
      k-icon(color="brand-warm-grey" size="18") close
</template>

<script>
import { BindsAttrs } from '@/mixins'

export default {
  mixins: [ BindsAttrs ],
  props: {
    color: {
      default: 'white',
      type: String,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    border: {
      type: [ String, Boolean ],
      default: false,
    },
    borderSize: {
      type: Number,
      default: 2,
    },
    boxShadow: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    styles () {
      return {
        border: this.border
          ? (this.borderSize + 'px solid var(--v-' + this.border + '-base) !important')
          : false,
      }
    },
    classes () {
      return {
        ['box-shadow--' + this.boxShadow]: !this.flat,
        'box-shadow--none': this.flat,
        'k-card--outline': this.outline
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.k-card {
  border-radius: 5px;
  position: relative;

  &::before {
    display: none;
  }

  &__button--close {
    color: #fff;
    opacity: .5;
    position: absolute;
    right: 25px;
    top: 27px;

    @include xs-only() {
      right: 15px;
      top: 12px;
    }
  }
}
</style>
